export enum Configuration {
    EMPTY = 'EMPTY',
    INITIATED = 'INITIATED',
    LOADED = 'LOADED',
    APPREADY = 'APPREADY',
    NETWORK_ISSUE = 'NETWORK_ISSUE',
    NETWORK_ISSUE_UNAUTHORIZED = 'NETWORK_ISSUE_UNAUTHORIZED',
}
